export default __webpack_public_path__ + "static/media/bubble_nova_background_xl2.cb81c896.jpg";